(function (angular) {
	'use strict';

	angular
		.module('baseCheckoutModule')
		.controller('CheckoutAmountSelect', [
			'$filter',
			'$timeout',
			'$window',
			'ADVANCED_SERVICE_LEVEL_OPTIONS',
			'AUTO_INVEST_AMOUNTS',
			'CheckoutFactory',
			'DEFAULT_PRINCIPAL_OPTIONS_INT',
			'FREQUENCY_OPTIONS',
			'globalConfig',
			'MONTHLY_DAY_OPTIONS',
			'SEMI_MONTHLY_DAY_OPTIONS',
			'OFUND_ORDER_AMOUNT_OPTIONS_INT',
			CheckoutAmountSelectFunction
		]);

	function CheckoutAmountSelectFunction(
		$filter,
		$timeout,
		$window,
		ADVANCED_SERVICE_LEVEL_OPTIONS,
		AUTO_INVEST_AMOUNTS,
		CheckoutFactory,
		DEFAULT_PRINCIPAL_OPTIONS_INT,
		FREQUENCY_OPTIONS,
		globalConfig,
		MONTHLY_DAY_OPTIONS,
		SEMI_MONTHLY_DAY_OPTIONS,
		OFUND_ORDER_AMOUNT_OPTIONS_INT
	) {	
		var checkout = this;

		function buildPayload() {
			var payload = {
				amount: checkout.amount.value
			};

			if(angular.isDefined(checkout.reitOfferingVintageId)) {
				payload.reitOfferingVintageId = checkout.reitOfferingVintageId;
			}

			if(angular.isDefined(checkout.riaPlanId)) {
				payload.riaPlanId = checkout.riaPlanId;
			}

			if(angular.isDefined(checkout.serviceLevel)) {
				payload.serviceLevelUpgrade = checkout.serviceLevel;
			}

			return payload;
		}

		function formSubmit() {
			$window.document.getElementById('recurringInvestmentScheduleCheckoutForm').submit();
		}

		function initAmountSelectFields() {
			if(angular.isDefined(checkout.reitType) && checkout.reitType === 'OPPORTUNITY_FUND') {
				checkout.amountOptions = angular.copy(OFUND_ORDER_AMOUNT_OPTIONS_INT);
			} else if(angular.isDefined(checkout.serviceLevel) && checkout.serviceLevel === 'ADVANCED') {
				checkout.amountOptions = angular.copy(ADVANCED_SERVICE_LEVEL_OPTIONS);
			} else {
				checkout.amountOptions = angular.copy(DEFAULT_PRINCIPAL_OPTIONS_INT);
			}

			checkout.amountOptions.push({
				value: parseInt(checkout.minimumInvestment),
				label: $filter('currency')(checkout.minimumInvestment, '$', 0),
				sortIndex: parseInt(checkout.minimumInvestment)
			});

			checkout.amount = $filter('filter')(checkout.amountOptions, {'value': parseInt(checkout.amount)}, true)[0];

			if(angular.isUndefined(checkout.amount)) {
				if(checkout.amount && checkout.amount >= parseInt(checkout.minimumInvestment)) {
					checkout.amount = {
						value: parseInt(checkout.amount),
						label: $filter('currency')(checkout.amount, '$', 0)
					};
				} else {
					checkout.amount = checkout.amountOptions[1];
				}
			}
		}

		function initAutoInvestFields() {
			checkout.autoAmountOptions = angular.copy(AUTO_INVEST_AMOUNTS);
			checkout.frequencyOptions = angular.copy(FREQUENCY_OPTIONS);
			checkout.dayOptions = angular.copy(MONTHLY_DAY_OPTIONS);

			if(globalConfig.existingAutoInvest) {
				checkout.autoAmount = $filter('filter')(checkout.autoAmountOptions, {'value': parseInt(globalConfig.autoAmount)}, true)[0];
				if(angular.isUndefined(checkout.autoAmount)) {
					checkout.autoAmount = {
						value: parseInt(globalConfig.autoAmount),
						label: $filter('currency')(globalConfig.autoAmount, '$', 0)
					};
				}

				checkout.frequency = $filter('filter')(checkout.frequencyOptions, {'value': globalConfig.autoFrequency})[0];
				if(globalConfig.autoFrequency === 'SEMI_MONTHLY') {
					checkout.dayOptions = angular.copy(SEMI_MONTHLY_DAY_OPTIONS);
				}
				checkout.firstInvestmentDayOfMonth = $filter('filter')(checkout.dayOptions, {'value': globalConfig.autoFirstDay})[0];
				checkout.addRecurringInvestmentSchedule = globalConfig.autoOn;
			} else {
				checkout.autoAmount = checkout.autoAmountOptions[2];
				checkout.frequency = checkout.frequencyOptions[0];
				checkout.firstInvestmentDayOfMonth = checkout.dayOptions[0];
				checkout.addRecurringInvestmentSchedule = 'false';
			}
		}

		function initInvestmentAmounts() {
			var orderDetails = {
				isIraEntity: checkout.isIraEntity
			};

			if(angular.isDefined(checkout.reitOfferingVintageId)) {
				orderDetails.reitOfferingVintageId = checkout.reitOfferingVintageId;
			}
			if(angular.isDefined(checkout.riaPlanId)) {
				orderDetails.riaPlanId = checkout.riaPlanId;
			}
			if(angular.isDefined(checkout.serviceLevel)) {
				orderDetails.serviceLevel = checkout.serviceLevel;
			}

			CheckoutFactory.getInvestmentRange(orderDetails)
				.then(function(investmentRange) {
					if(angular.isDefined(checkout.reitOfferingVintageId)) {
						checkout.minimumInvestment = investmentRange.achMinInvestment;
						checkout.maximumInvestment = investmentRange.wireMaxInvestment;
					} else {
						checkout.minimumInvestment = investmentRange.achMinInvestment;
						checkout.maximumInvestment = investmentRange.achMaxInvestment;
					}

					initAmountSelectFields();
				});

		}

		checkout.changeFrequency = function() {
			if(checkout.frequency.value === 'SEMI_MONTHLY') {
				checkout.dayOptions = angular.copy(SEMI_MONTHLY_DAY_OPTIONS);
			} else {
				checkout.dayOptions = angular.copy(MONTHLY_DAY_OPTIONS);
			}

			checkout.firstInvestmentDayOfMonth = checkout.dayOptions[0];
		};

		checkout.createOrderGroup = function() {
			CheckoutFactory.createOrderGroup(buildPayload())
				.then(function(data) {
					checkout.reitInvestmentOrderGroupId = data.orderGroupId;
					$timeout(function() {
						formSubmit();
					});
				})
				.catch(function() {
					checkout.formSubmitted = false;
				});
		};

		checkout.$onInit = function() {
			angular.extend(checkout, globalConfig);

			initInvestmentAmounts();
			initAutoInvestFields();
		};

	}
})(window.angular);